module.exports = __webpack_public_path__ + "img/组 1765@2x.1a2f3b63.png";